import {Profile} from "@web-libs/features/profile/domain/profile.types";
import {birthdayToStringDDMMYYYY, createBirthday} from "@web-libs/core/shared-domain/values/birthday";
import {OwnUserDTO} from "@web-libs/features/users/api/user-dto.types";

export type ProfileDTO = Omit<OwnUserDTO,"userTypes" | "id">

export type PasswordDTO = {
    currentPassword: string,
    newPassword: string
}

export function createProfileDTO(profile: Profile): ProfileDTO{
    return   {
        username: profile.username,
        firstName: profile.firstName,
        lastName: profile.lastName,
        email: profile.email,
        birth: profile.birth ? createBirthday(profile.birth) : undefined,
    }
}

export function parseProfileDTO(profileDTO: ProfileDTO): Profile{
    return {...profileDTO, birth: profileDTO.birth ?  birthdayToStringDDMMYYYY(new Date(profileDTO.birth)) : undefined};
}

export function  createPasswordDTO(_oldPassword: string, _newPassword: string): PasswordDTO{
    return {
        currentPassword : _oldPassword,
        newPassword: _newPassword
    }
}
